import axios from "axios";
import { coverIMGSET, coverIMG } from "../util/helper"



// 获取直播消息列表
export async function getChannelInfor() {
    try {
        const config = {
            method: 'get',
            url: `https://pubmod.hntv.tv/mobile/cms/articles?businessId=DXXWAPP_LY&channelId=1509370498043822081&commentVersion=v2&distinct_id=57927ACD-6B47-4087-BE67-98F983D2CB93&pageNo=1&pageSize=1&tenantId=1&userId=12756035038589788169`,
        }
        const { data } = await axios(config);
        if (data.code === 0) {
            
            const arr = [];
            for (const item of data.result.content) {
                arr.push({
                    id: item.id,
                    title: item.title,
                    des: item.des,
                    img: item.coverImagesList.map((e) => {
                        return {
                            url: e.url,
                            des: e.desc,
                            // 是否是封面图
                            coverBool: e.coverBool
                        }
                    }),
                })
            }
            const result = {
                state: 1,
                message: "获取数据成功！",
                data: arr
            };

            console.log(result)

            return result

        } else {
            return {
                state: 0,
                message: "初始化失败！0"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "初始化失败！"
        }
    }
}

// 获取客户端信息
export async function getDXArticles(atricleID, pageSize) {
    try {
        const config = {
            method: 'get',
            url: `https://pubmod.hntv.tv/mobile/cms/articles?channelId=${atricleID}&pageNo=1&pageSize=${pageSize}`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                arr.push(handleDXArticles(item))
            }
            return {
                state: 1,
                message: "获取列表成功！",
                data: {
                    channelId: atricleID,
                    // 当前页数
                    page: data.result.pageNo,
                    // 总页数
                    totalPage: data.result.totalPage,
                    list: arr
                }
            }

        } else {
            return {
                state: 0,
                message: "获取列表失败！1"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "获取列表失败！2"
        }
    }
}

// 获取栏目的扩展类型
export function handleEXT(ext, input, moren = false) {

    const res = ext.find(e => e.label == input);
    if (res) {
        // 转为字符串
        return res.fieldValue;
    } else {
        return moren
    }
}

function handleArticles(item) {
    // 无图3、三图2、双图4、大图1、单图0
    let articleType = 3;
    if (item.coverType !== 'null' && item.coverType) {
        articleType = isNaN(+item.coverType) ? 0 : +item.coverType;
    } else {
        articleType = handleArticleType(item.extFieldsList)
    }
    return {
        id: item.id,
        title: item.title,
        // 描述
        des: item.summary,
        // 来源
        from: item.origin,
        // 文章类型,默认类型级别最高,其次扩展类型
        articleType: articleType,
        // 是否是顶置文章
        top: item.topFlag === "1" ? true : false,
        publishDate: item.publishDate,
        // 封面图
        coverImagesList: item.coverImagesList.map((e) => {
            return {
                url: e.url,
                des: e.desc,
                // 是否是封面图
                coverBool: e.coverBool
            }
        }),
        url: item.articleType == 5 ? item.linkTo : item.forwardingUrl,
        type: item.articleType
    }
}

function handleDXArticles(item) {
    // 无图3、三图2、双图4、大图1、单图0
    let articleType = 3;
    if (item.coverType !== 'null' && item.coverType) {
        articleType = isNaN(+item.coverType) ? 0 : +item.coverType;
    } else {
        articleType = handleArticleType(item.extFieldsList)
    }
    return {
        id: item.id,
        title: item.title,
        // 描述
        des: item.summary,
        // 来源
        from: item.origin,
        // 文章类型,默认类型级别最高,其次扩展类型
        articleType: articleType,
        // 是否是顶置文章
        top: item.topFlag === "1" ? true : false,
        publishDate: item.publishDate,
        // 封面图
        coverImagesList: item.coverImagesList.map((e) => {
            return {
                url: e.url,
                des: e.desc,
                // 是否是封面图
                coverBool: e.coverBool
            }
        }),
        url: item.articleType == 5 ? item.linkTo : item.shareUrl,
        type: item.articleType
    }
}

function handleArticleType(ext) {
    const res = ext.find(e => e.label == '扩展类型');
    if (res) {
        // 转为字符串
        return +res.fieldValue;
    } else {
        return 0
    }
}

